import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SecurityPolicy from './SecurityPolicy';
import { Button, H2, Link } from '~COMPONENTS/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { LanguagePickerButton } from '../../static';

import { openModal } from '~COMPONENTS/modal/actions';

import { userTypes } from '../../types/user';

import { LOCALE_USA } from '../../static/languagePicker/constants';

import { GA_EVENT_CONTACT_US_CLICK, sendEventToGA } from '../../analytics/constants';

const SERVICE_URL = 'https://agreementservice.svs.nike.com/us/en_us/rest/agreement';

const buildUrl = (type, country, lang) =>
  `${SERVICE_URL}?agreementType=${type}&uxId=com.nike.elite&country=${
    country || 'US'
  }&language=${lang}&requestType=styled_body`;

const handleContactUsClick = () => {
  sendEventToGA(GA_EVENT_CONTACT_US_CLICK);
};

export const HomepageFooter = ({ openModal, user }) => {
  const userLanguage = user && user.locale ? user.locale.split('_')[0] : LOCALE_USA.split('_')[0];
  const userCountry = user && user.country;

  const handleSecurityClick = () => {
    openModal({
      type: 'custom',
      element: <SecurityPolicy />
    });
  };

  return (
    <div className='homepage__footer body-4 bg-black ta-sm-c ta-md-l u-full-width'>
      <div className='flex-container border-bottom row u-full-width space-between align-center'>
        <Link to='/contact-us' onClick={handleContactUsClick}>
          <H2 className='pt5-sm pb5-sm pl7-sm pl10-md text-color-primary-light'>
            <TranslatedCopy id='global.contact' />
          </H2>
        </Link>
        <LanguagePickerButton locale={(user && user.locale) || LOCALE_USA} extraClassName='mr7-sm mr10-md' />
      </div>
      <div className='p1-sm prl10-md text-color-secondary u-full-width'>
        <ul className='flex-container row'>
          <li className='prl5-sm prl2-md'>
            <Button textLink className='text-color-secondary' onClick={handleSecurityClick}>
              <TranslatedCopy id='homepage.footer.security' />
            </Button>
          </li>
          <li className='prl5-sm prl2-md'>
            <Link to={buildUrl('termsOfUse', userCountry, userLanguage)} external className='text-color-secondary'>
              <TranslatedCopy id='homepage.footer.terms' />
            </Link>
          </li>
          <li className='prl5-sm prl2-md'>
            <Link to={buildUrl('privacyPolicy', userCountry, userLanguage)} external className='text-color-secondary'>
              <TranslatedCopy id='homepage.footer.privacy' />
            </Link>
          </li>
        </ul>
      </div>
      <div className='flex-container center text-color-secondary border-top pt1-sm pb1-sm'>
        <TranslatedCopy id='global.copyright' values={{ year: new Date().getFullYear() }} />
      </div>
    </div>
  );
};

HomepageFooter.defaultProps = {
  user: null
};

HomepageFooter.propTypes = {
  openModal: PropTypes.func.isRequired,
  user: userTypes
};

const connector = connect(null, { openModal });

export default connector(HomepageFooter);
